// Generated from ui/src/brand/brand.json by ui/tools/sync_brand.mjs. Do not edit: change brand.json and run the tool.
import type { BrandConfig } from './types';

export const BRAND_DEFAULT: BrandConfig = {
  "version": 1,
  "name": "Dugzi",
  "legal": {
    "controller": "AskOwlo BV",
    "country": "NL",
    "note": "The data controller named in consent screens, privacy notices and legal mail. A tenant's branding never replaces it."
  },
  "domains": {
    "public": "dugzi.com",
    "mail": "dugzi.com",
    "identifiers": "dugzi.com",
    "development": "dugzi.localhost",
    "developmentMail": "dugzi.test",
    "note": "identifiers: the domain inside identifiers we mint (iCalendar UIDs, Message-IDs). Never change it on a running deployment, even in a rebrand: mail and calendar apps recognise existing items by it."
  },
  "addresses": {
    "support": "support",
    "privacy": "privacy",
    "security": "security",
    "abuse": "abuse",
    "legal": "legal",
    "accessibility": "accessibility",
    "noreply": "noreply"
  },
  "assets": {
    "wordmark": "assets/wordmark",
    "mascot": "assets/mascot",
    "mascotEnabled": true,
    "note": "Paths inside @dugzi/ui. A white-label build swaps these folders and the tokens; the code reads the wordmark through <Wordmark>, never by file name."
  },
  "products": {
    "mail": {
      "name": "Mail",
      "host": "mail"
    },
    "calendar": {
      "name": "Calendar",
      "host": "calendar"
    },
    "chat": {
      "name": "Chat",
      "host": "chat"
    },
    "contacts": {
      "name": "Contacts",
      "host": "contacts"
    },
    "drive": {
      "name": "Drive",
      "host": "drive"
    },
    "docs": {
      "name": "Docs",
      "host": "docs"
    },
    "sheets": {
      "name": "Sheets",
      "host": "sheets"
    },
    "slides": {
      "name": "Slides",
      "host": "slides"
    },
    "tasks": {
      "name": "Tasks",
      "host": "tasks"
    },
    "notes": {
      "name": "Notes",
      "host": "notes"
    },
    "wiki": {
      "name": "Wiki",
      "host": "wiki"
    },
    "search": {
      "name": "Search",
      "host": "search"
    },
    "ai": {
      "name": "Ask {brand}",
      "host": "ai"
    },
    "account": {
      "name": "Account",
      "host": "accounts"
    },
    "code": {
      "name": "Code",
      "host": "code"
    },
    "work": {
      "name": "{brand} Work",
      "host": "work"
    }
  }
};
